import request from '@/router/axios'
import env from '@/config/env'

/**
 * 获取出发站点列表
 * @param lineId
 */
export const getStarStationList = (lineId, startDate) => {
  return request({
    url: env.ferryUrl + `/section/getDepartureStation/${lineId}/${startDate}`,
    method: 'GET'
  })
}

/**
 * 获取目的地站点列表
 * @param lineId
 */
export const getEndStationList = (lineId, startDate) => {
  return request({
    url: env.ferryUrl + `/section/getDestinationStation/${lineId}/${startDate}`,
    method: 'GET'
  })
}

/**
 * 区间列表
 */
export const application = (data) => {
  return request({
    url: env.ferryUrl + '/section/v2/list',
    method: 'POST',
    data
  })
}

/**
 * 分页列表
 */
export const getPage = (data) => {
  return request({
    url: env.ferryUrl + '/section/page',
    method: 'post',
    data
  })
}
/**
 * 分页列表
 */
export const getMerchant = (lineId) => {
  return request({
    url: env.ferryUrl + `/c-order/merchant/${lineId}`,
    method: 'GET'
  })
}

export const setLockSeat = (data) => {
  return request({
    url: env.ferryUrl + '/section/lockSeat',
    method: 'POST',
    data
  })
}

export const stationList = (areaId) => {
  return request({
    url: env.ferryUrl + '/stationManage/selectList',
    method: 'get',
    params: {
      areaId
    }
  })
}

export const getSeatState = (sectionId) => {
  return request({
    url: env.ferryUrl + '/section/sectionSeat',
    method: 'get',
    params: {
      sectionId
    }
  })
}
// 获取所有电子围栏
export const areaCoveragePoints = (data) => {
  return request({
    url: env.ferryUrl + '/section/areaCoverage',
    // url: env.ferryUrl + '/section/AreaCoveragePoints',
    method: 'post',
    data
  })
}
// 获取当前点是否在区域内
export const checkInArea = (data) => {
  return request({
    url: env.ferryUrl + '/section/ckeckInArea',
    method: 'post',
    data
  })
}
// 获取点到站点的接送费
export const ferryAmount = (data) => {
  return request({
    url: env.ferryUrl + '/section/ferry/v2/amount',
    method: 'post',
    data
  })
}
// 提交订单
export const submitOrder = (data) => {
  return request({
    url: env.ferryUrl + '/section/v2/submit',
    // url: env.ferryUrl + '/section/submit',
    method: 'post',
    data
  })
}

export const bossOrderInfo = (sectionId) => {
  return request({
    url: env.ferryUrl + `/section/bossOrderInfo?sectionId=${sectionId}`,
    method: 'get'
  })
}
// 获取指定日期线路下的发车时间
export const flightPlanTime = (params) => {
  return request({
    url: env.ferryUrl + '/section/flightPlanTime',
    method: 'post',
    data: params
  })
}

// 根据已售座位获取订单 ID
export const queryOrderIdBySeat = (params) => {
  return request({
    url: env.ferryUrl + '/c-order/queryOrderIdBySeat',
    method: 'get',
    params
  })
}
